import React from 'react';
import Icon from '../Icon';
import styles from './styles.module.scss';

export default () => <Icon icon="angle-right" className={styles['separator']} />;
